import React, { useEffect, useState } from 'react'
import Filter from '../components/Filter'
import { sampleProducts } from '../lib/FakeData'
import ProductCard from '../components/ProductCard'
import ProductCard3 from '../components/ProductCard3'
import { FaTh, FaThLarge, FaThList } from 'react-icons/fa'
import { BsColumnsGap } from 'react-icons/bs'
import { TfiLayoutGrid2, TfiLayoutGrid3, TfiLayoutGrid4, TfiLayoutListThumbAlt } from 'react-icons/tfi'
import { isMobile } from '../service'
import { CiSliderHorizontal } from 'react-icons/ci'
import Drawer from '../components/commons/Drawer'
import { IoMdClose } from 'react-icons/io'
import { listProduct } from "../redux/Actions/ProductActions";
import { useDispatch, useSelector } from 'react-redux'
import Breadcrumb from '../components/Breadcrumb'
const Category = ({ history, match }) => {
    const cateId= match.params.id;
    const [sort, setSort] = useState("best-selling");
    const [view, setView] = useState(isMobile() ? "grid-cols-2" : "grid-cols-4"); // grid | 2col | list
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const productList = useSelector((state) => state.productList);
    const { loading, error, products } = productList;
    const currentProducts = products.filter((product) => product?.category === cateId)
    // useEffect(() => {
    //     dispatch(listProduct());
    //     return () => {

    //     };
    // }, [dispatch]);
    const breadcrumbItems = [
        { label: "Trang chủ", href: "/" },
        { label: "Danh mục", href: "/category" },
    ];
    return (
        <>  
         <Breadcrumb items={breadcrumbItems} />
            <div className='w-full flex items-center justify-center my-4 p-4 xl:p-0'>
                <div className='w-[--page-width] grid grid-cols-12 gap-4 xl:gap-0'>
                    <div className='hidden md:block md:col-span-4 lg:col-span-3 '>
                        <Filter />
                    </div>
                    <div className='col-span-12 md:col-span-8  lg:col-span-9 flex flex-col gap-2'>
                        <div className=''>
                            <div className="flex items-center justify-between md:justify-end  gap-4">
                                {/* Left: product count */}
                                <span className="text-sm text-gray-700">{products && products?.length} sản phẩm</span>

                                {/* Middle: Sort by */}
                                <div className=" items-center gap-2 hidden md:flex">
                                    <span className="text-sm">Sắp xếp theo:</span>
                                    <select
                                        value={sort}
                                        onChange={(e) => setSort(e.target.value)}
                                        className="border rounded px-2 py-1 text-sm"
                                    >
                                        <option value="best-selling">Bán chạy</option>
                                        <option value="price-asc">Giá: Thấp đến cao</option>
                                        <option value="price-desc">Giá: Cao đến thấp</option>
                                        <option value="newest">Mới</option>
                                    </select>
                                </div>

                                {/* Right: view toggle */}
                                <div className="flex items-center gap-1">
                                    <button
                                        onClick={() => setView("grid-cols-4")}
                                        className={`hidden xl:block p-2 rounded ${view === "grid-cols-4" ? "bg-green-500 text-white" : "bg-gray-100"}`}
                                    >
                                        <TfiLayoutGrid4 size={14} />
                                    </button>
                                    <button
                                        onClick={() => setView("grid-cols-3")}
                                        className={`hidden lg:block p-2 rounded ${view === "grid-cols-3" ? "bg-green-500 text-white" : "bg-gray-100"}`}
                                    >
                                        <TfiLayoutGrid3 size={14} />
                                    </button>
                                    <button
                                        onClick={() => setView("grid-cols-2")}
                                        className={`p-2 rounded ${view === "grid-cols-2" ? "bg-green-500 text-white" : "bg-gray-100"}`}
                                    >
                                        <TfiLayoutGrid2 size={14} />
                                    </button>
                                    <button
                                        onClick={() => setView("grid-cols-1")}
                                        className={`p-2 rounded ${view === "grid-cols-1" ? "bg-green-500 text-white" : "bg-gray-100"}`}
                                    >
                                        <TfiLayoutListThumbAlt size={14} />
                                    </button>
                                </div>
                            </div>

                        </div>
                        <button className='flex md:hidden items-center  gap-4 border rounded-lg px-4 py-1' onClick={() => setOpen(true)}>
                            <CiSliderHorizontal />
                            <span className='text-sm'>Bộ lọc và sắp xếp</span>
                        </button>
                        <div className={`grid ${view} gap-4`}>
                            {currentProducts && currentProducts?.map((value, index) => {
                                if (view == "grid-cols-1") {
                                    return <ProductCard3 showDes={true} size='large' product={value} />

                                } else {
                                    return <ProductCard product={value} />

                                }
                            })}
                            {!currentProducts || currentProducts.length<=0 && <p>Không có dữ liệu</p>}
                        </div>
                    </div>

                </div>
                <Drawer isOpen={open} onClose={() => setOpen(false)} width="w-80">
                    <div className='h-screen w-full'>
                        <div className="py-2 px-4 h-[50px] flex justify-between items-center bg-[--color-button-3]">

                            <p className='text-white'>Bộ lọc và sắp xếp</p>
                            <button
                                className='text-white'
                                onClick={() => setOpen(false)}
                            >
                                <IoMdClose />
                            </button>
                        </div>
                        <div className='py-2 px-4 h-[calc(100%-50px)] overflow-y-scroll no-scrollbar w-full '>
                            <div className="flex  items-center gap-2 mb-4 w-full">
                                <span className="text-sm">Sort by:</span>
                                <select
                                    value={sort}
                                    onChange={(e) => setSort(e.target.value)}
                                    className="border rounded px-2 py-1 text-sm"
                                >
                                    <option value="best-selling">Best selling</option>
                                    <option value="price-asc">Price: Low to High</option>
                                    <option value="price-desc">Price: High to Low</option>
                                    <option value="newest">Newest</option>
                                </select>
                            </div>
                            <Filter />
                        </div>

                    </div>
                </Drawer>
            </div>
        </>
    )
}
export default Category
